/**
 * Period types and utilities
 * Period represents a specific month/year for data filtering
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpClient } from "@/lib/http";
import { getMonthName } from "@/lib/intl-formatters";
import { capitalize } from "@/lib/text-utils";
const LOCALE = "es-ES";
function fetchMonthYearList(table) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = "/webapi/cross/month-year-list?tableclass=" + table;
        const response = yield HttpClient.get(url);
        return [...response];
    });
}
function fetchDefaultPeriodData() {
    return __awaiter(this, void 0, void 0, function* () {
        const url = "/webapi/cross/default-period";
        const response = yield HttpClient.get(url);
        return response;
    });
}
export function fetchAvailablePeriods(table) {
    return __awaiter(this, void 0, void 0, function* () {
        const yearMonthList = yield fetchMonthYearList(table);
        return yearMonthList
            .map((item) => {
            const year = parseInt(item.ano_natural);
            const month = parseInt(item.mes_natural);
            const customLabel = `${item.mes_name} ${year}`;
            return {
                key: `${year}-${String(month).padStart(2, "0")}`,
                label: customLabel,
                year,
                month,
                month_name: item.mes_name
            };
        })
            .sort((a, b) => {
            // Sort in descending order (newest first)
            if (a.year !== b.year) {
                return b.year - a.year;
            }
            return b.month - a.month;
        });
    });
}
export function getDefaultPeriod() {
    // Fallback period if backend is not available
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    return getPeriod(year, month);
}
export function fetchDefaultPeriod() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const defaultPeriodData = yield fetchDefaultPeriodData();
            const year = parseInt(defaultPeriodData.ano_natural);
            const month = parseInt(defaultPeriodData.mes_natural);
            const customLabel = `${defaultPeriodData.mes_name} ${year}`;
            return {
                key: `${year}-${String(month).padStart(2, "0")}`,
                label: customLabel,
                year,
                month,
                month_name: defaultPeriodData.mes_name
            };
        }
        catch (error) {
            // Fallback to local calculation if backend fails
            console.warn('Failed to fetch default period from backend, using fallback:', error);
            return getDefaultPeriod();
        }
    });
}
export function fetchResultsActionAvailability(period) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield HttpClient.get("/webapi/cross/results-action-availability", {
            ano_natural: period.year,
            mes_natural: period.month,
        });
        return {
            dateUsed: response.date_used,
            currentYear: response.current_year,
            currentPeriod: response.current_period,
            selectedYear: response.selected_year,
            selectedPeriod: response.selected_period,
            targetYear: response.target_year,
            targetPeriod: response.target_period,
            selectedMatchesTarget: response.selected_matches_target,
            canEdit: response.can_edit,
            canValidate: response.can_validate,
            editionStartDate: response.edition_start_date,
            editionEndDate: response.edition_end_date,
            validationStartDate: response.validation_start_date,
            validationEndDate: response.validation_end_date,
        };
    });
}
const periodsCache = {};
export function getPeriod(year, month) {
    const key = `${year}-${String(month).padStart(2, "0")}`;
    if (!periodsCache[key]) {
        periodsCache[key] = createPeriod(year, month);
    }
    return periodsCache[key];
}
function createPeriod(year, month) {
    const date = new Date(year, month - 1);
    const month_name = getMonthName(month);
    const label = `${capitalize(month_name)} ${year}`;
    const key = `${year}-${String(month).padStart(2, "0")}`;
    return { key, label, year, month, month_name };
}
